export const isValidBRPhone = (phone: string): boolean => {
  const cleaned = phone.replace(/\D/g, '');
  return /^([1-9]{2})9\d{8}$/.test(cleaned);
};

export const isValidCOPhone = (phone: string): boolean => {
  const cleaned = phone.replace(/\D/g, '');
  return /^3\d{9}$/.test(cleaned);
};

export const isValidPhone = (phone: string, country: string): boolean => {
  if (country === 'BR') return isValidBRPhone(phone);
  if (country === 'CO') return isValidCOPhone(phone);
  return false;
};
